/**
 * 深度 / 法线：仅请求后端 RunningHub，不经过 Gemini 图像模型。
 */
import { api } from './apiClient';
import { validateAndFixImageFormat } from './geminiService';

export async function runDepthNormalMaps(
  base64Image: string,
  dimensions: { width: number; height: number },
  userEmail?: string,
): Promise<{
  depthImage: string;
  normalImage: string;
  imageCredits?: number;
  balance?: number;
}> {
  const validated = validateAndFixImageFormat(base64Image);
  const response: any = await api.submitDepthNormalRunningHub(validated, dimensions, userEmail);
  if (!response?.depthImage || !response?.normalImage) {
    throw new Error(response?.message || response?.error || '空间结构数据未返回完整图片');
  }
  return {
    depthImage: response.depthImage,
    normalImage: response.normalImage,
    imageCredits: response.imageCredits,
    balance: response.balance,
  };
}
